/* tslint:disable */
/* eslint-disable */
/**
 * LWM portal
 * Lamb-Weston Meijer Portal API documentation
 *
 * The version of the OpenAPI document: 3.3.10
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { UserVendor } from './user-vendor';

/**
 *
 * @export
 * @interface InlineObject2
 */
export interface InlineObject2 {
    /**
     *
     * @type {string}
     * @memberof InlineObject2
     */
    email: string;
    /**
     *
     * @type {string}
     * @memberof InlineObject2
     */
    locale: string;
    /**
     *
     * @type {string}
     * @memberof InlineObject2
     */
    group: string;
    /**
     * Required if the created user is a direct customer
     * @type {string}
     * @memberof InlineObject2
     */
    sapId?: string;
    /**
     * Required if the created user is a direct customer
     * @type {Array<string>}
     * @memberof InlineObject2
     */
    sapIds?: Array<string>;
    /**
     * Phone number, required if set_mfa=true
     * @type {string}
     * @memberof InlineObject2
     */
    phone?: string | null;
    /**
     * Set MFA for this user, if \'true\' phone must also be provided
     * @type {boolean}
     * @memberof InlineObject2
     */
    set_mfa?: boolean;
    /**
     *
     * @type {string}
     * @memberof InlineObject2
     */
    country?: string;
    /**
     *
     * @type {UserVendor}
     * @memberof InlineObject2
     */
    vendor?: UserVendor;
    /**
     * List of product types associated with the user, can be optionally provided when the user is a dock-scheduling-user
     * @type {Array<string>}
     * @memberof InlineObject2
     */
    product_groups?: Array<InlineObject2ProductGroupsEnum>;
}

/**
    * @export
    * @enum {string}
    */
export enum InlineObject2ProductGroupsEnum {
    Batter = 'Batter',
    Foil = 'Foil',
    Boxes = 'Boxes',
    Pallets = 'Pallets',
    AmbientFinished = 'Ambient_Finished',
    FrozenFinished = 'Frozen_Finished',
    FrozenBulk = 'Frozen_Bulk',
    Oil = 'Oil',
    Salt = 'Salt',
    IngredientsOther = 'Ingredients_Other',
    Transport = 'Transport'
}



